import { KYMW0C00Model } from '../kymw0c00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像作成指示画面　画像種別単位の登録上限件数を取得するサービス
 *
 * @export GetImageTypeLimitService
 * @class GetImageTypeLimitService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetImageTypeLimitService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetImageTypeLimitService
   */
  private model: KYMW0C00Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetImageTypeLimitService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetImageTypeLimitService
   */
  execute(model: any, successFunc: Function): void {
    this.model = <KYMW0C00Model>model;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetImageTypeLimit', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageTypeLimitService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
